import { render, staticRenderFns } from "./LargeLabels.vue?vue&type=template&id=5ab164b0&scoped=true"
import script from "./LargeLabels.vue?vue&type=script&lang=js"
export * from "./LargeLabels.vue?vue&type=script&lang=js"
import style0 from "./LargeLabels.vue?vue&type=style&index=0&id=5ab164b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab164b0",
  null
  
)

export default component.exports